import React, { useEffect, useState } from 'react';
// import CrossButton from '~images/loggedout/icons/cross.svg';
import Image from '../../../../app/js/components/loggedout/common/Image';
import * as S from './style';
import Vimeo from '@u-wave/react-vimeo';
import { BodyScrollLock, isIOS } from '../../../../app/js/utils/web-helper';

const VideoModal = ({ videoOverlayCloseHandler, videoSrc, startTime = 0, trackPromoPageEvents }) => {
  
  const [videoCurrentTime, setVideoCurrentTime] = useState(0);
  const [isVideoReady, setVideoReady] = useState(false);

  useEffect(() => {
    //trackEventOnGA('clicked video', 'homepage');
    let BodyScrollObj = new BodyScrollLock;
    BodyScrollObj.lock();
    return () => {
      BodyScrollObj.unlock();
    }
  }, []);
  
  const onVideoReady = () => setVideoReady(true);
  const onVideoEnd = () => {
    trackEventOnGA('Completed video');
    trackPromoPageEvents("Video Interacted", {"Interaction" : "Video Completed"});
    // trackEventOnFacebook('Completed video');
    if (typeof dataLayer != "undefined") {
      trackToGtm(dataLayer, 'Completed video', 'Completed video');
    }

    videoOverlayCloseHandler();
  }

  const onVideoPlay = () => {
    trackEventOnGA('Started the video');
    // trackEventOnFacebook('Started the video');
    trackPromoPageEvents("Video Started");
    if (typeof (dataLayer) != "undefined") {
      trackToGtm(dataLayer, 'Started the video', 'Started the video');
    }
  }

  const onTimeUpdate = (data) => {
    if (data.seconds - videoCurrentTime > 1) {
      setVideoCurrentTime(data.seconds);
    }
  }

  const onVolumeChange = (vol) => {
    return vol === 0 ? trackAnalyticsEvent('Interacted Video Screen', { 'Tapped On': 'mute' }) : null;
  }

  const onVolumeChangeVideo = (data) => {
    onVolumeChange && onVolumeChange(data.volume);
  }

  const onErrorHandler = () => {
    console.log('ERROR LOADING VIDEO');
    videoOverlayCloseHandler();
  }

  const onVideoPaused = () =>{
    trackPromoPageEvents("Video Interacted",{"Interaction" : "Video Paused"});
  }

  const onVideoClosed = () =>{
    trackPromoPageEvents("Video Interacted",{"Interaction" : "Video Closed"});
    videoOverlayCloseHandler();
  }

  return (
    <S.VideoOverlay id='video-modal'>
      <S.VideoContainer isVideoReady={isVideoReady}>
        <Vimeo 
          video={videoSrc} 
          style={{height: '100%'}} 
          autoplay 
          muted={isIOS()} 
          onPlay={() => onVideoPlay()}
          onEnd={() => onVideoEnd()} 
          onReady={() => onVideoReady()} 
          onTimeUpdate={(data) => onTimeUpdate(data)} 
          onVolumeChange={(data) => onVolumeChangeVideo(data)}
          onError={() => onErrorHandler()}
          start={startTime}
          onPause={()=> onVideoPaused()}
        />
        <S.CrossBtn onClick={onVideoClosed} />
      </S.VideoContainer>
    </S.VideoOverlay>
  )
}

export default VideoModal;